module.exports = __webpack_public_path__ + "static/media/dog-husky.1dc4375c.png";